import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Button } from '../../../../../../../components/Button/Button'

export interface ObjectMappingsListProps<T> {
  items: T[]
  isLoading: boolean
  renderRow: (item: T, index: number) => React.ReactNode
  getKey: (item: T, index: number) => string
  onAddObject: () => void
  addButtonLabel: string
}

export const ObjectMappingsList = <T,>({ items, isLoading, renderRow, getKey, onAddObject, addButtonLabel }: ObjectMappingsListProps<T>) => {
  if (isLoading) {
    return (
      <Container>
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
      </Container>
    )
  }

  return (
    <>
      <div className='d-flex flex-column gap-3'>
        {items.map((item, index) => (
          <React.Fragment key={getKey(item, index)}>{renderRow(item, index)}</React.Fragment>
        ))}
      </div>
      <Row className='mt-3'>
        <Col className='p-0'>
          <Button type='button' variant='primaryGhost' className='border-0' onClick={onAddObject}>
            {addButtonLabel}
          </Button>
        </Col>
      </Row>
    </>
  )
}
